export default __webpack_public_path__ + "static/skills3-5a532f0c6eba5f25cec7afffddbf328f.svg";